import { render } from "./BookingConfirmationView.vue?vue&type=template&id=bdccb754"
import script from "./BookingConfirmationView.vue?vue&type=script&lang=js"
export * from "./BookingConfirmationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__